module.exports = __webpack_public_path__ + "img/cap_02.eed8910e.jpg";